(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rtb-loader"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', function () {
    document.body.classList.add('loaded');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rtb-product-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
// SWIPER
swiperThumbs = new Swiper('.top__wrapper .swipper-thumbs', {
spaceBetween: 10,
slidesPerView: 4,
freeMode: true,
watchSlidesProgress: true,
breakpoints: {
992: {
direction: 'vertical',
},
0: {
direction: 'horizontal',
},
},
});

swiperVitrine = new Swiper('.top__wrapper .swipper-container', {
initialSlide: parseInt((document.querySelector('.top__wrapper .swipper-container') || {}).getAttribute?.('data-rt-initial') || '0', 10) || 0,
spaceBetween: 10,
pagination: {
el: '.swiper-pagination',
clickable: true,
},
navigation: {
nextEl: '.swiper-button-next',
prevEl: '.swiper-button-prev',
},
pagination: {
el: '.swiper-pagination',
type: 'fraction',
},
thumbs: {
swiper: swiperThumbs,
},
});

// REDTEC · toca o vídeo só quando o slide dele está ativo
function rtPdpVideos() {
document.querySelectorAll('.top__wrapper .swipper-container .rt-pdp-video').forEach(function (slide) {
var v = slide.querySelector('video');
var btn = slide.querySelector('.rt-pdp-video__toggle');
if (!v) return;
if (slide.classList.contains('swiper-slide-active')) {
if (!v.dataset.rtUserPaused) {
v.muted = true;
var p = v.play();
if (p && p.catch) p.catch(function () {});
}
if (btn) btn.hidden = false;
} else {
v.pause();
}
});
}
document.querySelectorAll('.rt-pdp-video__toggle').forEach(function (btn) {
btn.addEventListener('click', function (e) {
e.stopPropagation();
var v = btn.parentNode.querySelector('video');
if (!v) return;
if (v.paused) { delete v.dataset.rtUserPaused; v.play(); btn.classList.remove('is-paused'); btn.setAttribute('aria-label', 'Pausar vídeo'); }
else { v.dataset.rtUserPaused = '1'; v.pause(); btn.classList.add('is-paused'); btn.setAttribute('aria-label', 'Reproduzir vídeo'); }
});
});
var rtPill = document.querySelector('[data-rt-go-video]');
var rtSlides = document.querySelectorAll('.top__wrapper .swipper-container .swiper-slide');
var rtVidIdx = -1;
rtSlides.forEach(function (sl, i) { if (rtVidIdx < 0 && sl.classList.contains('rt-pdp-video')) rtVidIdx = i; });
function rtPillState() { if (rtPill && swiperVitrine) rtPill.classList.toggle('is-hidden', swiperVitrine.activeIndex === rtVidIdx); }
if (rtPill && rtVidIdx > -1) {
rtPill.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); swiperVitrine.slideTo(rtVidIdx); });
}
document.querySelectorAll('.rt-pdp-video').forEach(function (slide) {
var v = slide.querySelector('video');
var big = slide.querySelector('.rt-pdp-video__play');
if (!v) return;
v.addEventListener('playing', function () { slide.classList.add('is-playing'); });
v.addEventListener('pause', function () { slide.classList.remove('is-playing'); });
if (big) big.addEventListener('click', function (e) { e.stopPropagation(); delete v.dataset.rtUserPaused; v.muted = true; v.play(); });
});
if (swiperVitrine && swiperVitrine.on) {
swiperVitrine.on('slideChange', rtPillState);
swiperVitrine.on('slideChangeTransitionEnd', rtPdpVideos);
swiperVitrine.on('slideChange', rtPdpVideos);
}
rtPdpVideos();
rtPillState();

function markActiveSlide() {
const inputActive = document.querySelector('input[data-current-checked="true"][data-featured-media-id]');
if (!inputActive) return;
const mediaId = inputActive.dataset.featuredMediaId;
if (!mediaId) return;
const slides = document.querySelectorAll('.swiper-slide');
slides.forEach((slide, index) => {
if (slide.dataset.mediaId === mediaId) {
swiperVitrine.slideTo(index, 300);
}
});
}

// Vir com uma imagem selecionada
// markActiveSlide();

document.addEventListener('change', function (e) {
if (e.target.matches('input[data-featured-media-id]')) {
markActiveSlide();
}
});

// Modal Video
const modal = document.querySelector('.pdp-video-modal');
const openBtn = document.querySelector('.product__badge-video');
const closeBtn = modal?.querySelector('.pdp-video-close');
const overlay = modal?.querySelector('.pdp-video-overlay');
const iframe = modal?.querySelector('iframe');

if (modal && openBtn && iframe) {
const originalSrc = iframe.dataset.src || iframe.src; /* REDTEC LCP: YouTube só carrega ao abrir */

function openModal() {
modal.hidden = false;
document.body.style.overflow = 'hidden';
iframe.src = originalSrc;
}

function closeModal() {
modal.hidden = true;
document.body.style.overflow = '';
iframe.src = 'about:blank';
}
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && !modal.hidden) {
closeModal();
}
});
openBtn.addEventListener('click', openModal);
closeBtn?.addEventListener('click', closeModal);
overlay?.addEventListener('click', closeModal);
}
});
  } catch(e) { console.error(e); }
})();

})();
